import { toast } from '@journ/ui/use-toast'
import { createLogger } from '@/utils/logger'
import type { NotificationInput, NotificationsPort } from '../domain/notification'

const log = createLogger()

const levelToVariant = { info: 'info', success: 'success', warn: 'info', error: 'error' } as const

let idCounter = 0
const genId = () => `notification-${++idCounter}`

const makePushNotification = (port: NotificationsPort) => (input: NotificationInput) => {
	const id = genId()
	const notification = { ...input, id, status: 'unread' as const, createdAt: new Date().toISOString() }

	port.push(notification)

	if (notification.level === 'error') log.error(notification.message, { title: notification.title })
	else if (notification.level === 'warn') log.warn(notification.message, { title: notification.title })
	else log.log(notification.message, { title: notification.title })

	if (notification.variant === 'toast') {
		toast({
			id,
			title: notification.title,
			description: notification.message,
			variant: levelToVariant[notification.level],
			duration: notification.duration,
		})
	}

	return id
}

export { makePushNotification }
